<template>
  <button class="text-button" @click="$emit('click', $event)">
    <slot name="prefix">
      <div v-if="$slots.prefix" class="prefix-icon">
        <slot name="prefix"></slot>
      </div>
    </slot>
    <span class="button-text">
      <slot>{{ text }}</slot>
    </span>
  </button>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: 'Button Text'
  }
});

defineEmits(['click']);
</script>

<style scoped>
.text-button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.text-button:hover {
  background: rgba(30, 70, 112, 0.08);
}

.text-button:active {
  background: rgba(30, 70, 112, 0.12);
}

.prefix-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.button-text {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #1E4670;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
